import { Form, Input, Modal } from 'antd';
import { TextEditor } from 'components/lib';
import { convertToRaw, EditorState } from 'draft-js';
import { useSuccessMessage } from 'hooks';
import { draftToMarkdown } from 'markdown-draft-js';
import { useState } from 'react';
import { CreateMacroParams, useCreateMacroMutation } from 'services/macros.service';
import { BaseModalProps } from 'utils/types';

enum NEW_MACRO_FIELDS {
    LABEL = 'label',
    CONTENT = 'content',
    KEY_WORD = 'key_word',
    DESCRIPTION = 'description',
}

const initalMacroState: CreateMacroParams = {
    [NEW_MACRO_FIELDS.LABEL]: '',
    [NEW_MACRO_FIELDS.CONTENT]: '',
    [NEW_MACRO_FIELDS.KEY_WORD]: '',
    [NEW_MACRO_FIELDS.DESCRIPTION]: '',
};

interface AddMacroModalProps extends BaseModalProps {}

const AddMacroModal: React.FC<AddMacroModalProps> = ({ isOpen, setIsOpen }) => {
    const [form] = Form.useForm<CreateMacroParams>();

    const [note, setNote] = useState(EditorState.createEmpty());

    const [createMacro, { isSuccess, isError, isLoading }] = useCreateMacroMutation();

    const handleClose = () => {
        setIsOpen(false);
    };

    useSuccessMessage({
        success: {
            status: isSuccess,
            message: `New '${form.getFieldValue(NEW_MACRO_FIELDS.LABEL)}' macro has been successfully created.`,
            callback: () => {
                handleClose();
                form.resetFields();
            },
        },
        error: {
            status: isError,
            message: `It seems there has been an issue adding the macro '${form.getFieldValue(NEW_MACRO_FIELDS.LABEL)}', please try again.`,
        },
    });

    const handleSave = (values: CreateMacroParams) => {
        let content = draftToMarkdown(convertToRaw(note.getCurrentContent()));
        createMacro({ ...values, content });
    };

    const handleFail = () => {};
    return (
        <Modal title='Add Macro' open={isOpen} onOk={form.submit} onCancel={handleClose}>
            <Form
                form={form}
                name='basic'
                labelCol={{ span: 6 }}
                wrapperCol={{ span: 18 }}
                initialValues={initalMacroState}
                onFinish={handleSave}
                onFinishFailed={handleFail}
            >
                <Form.Item
                    label='Label'
                    name={NEW_MACRO_FIELDS.LABEL}
                    rules={[
                        {
                            required: true,
                            message: 'Please ensure the macro label has been entered.',
                        },
                    ]}
                >
                    <Input />
                </Form.Item>
                <Form.Item
                    label='Keyword'
                    name={NEW_MACRO_FIELDS.KEY_WORD}
                    rules={[
                        {
                            required: true,
                            message: 'Please ensure the macro keyword has been entered.',
                        },
                    ]}
                >
                    <Input />
                </Form.Item>
                <Form.Item
                    label='Description'
                    name={NEW_MACRO_FIELDS.DESCRIPTION}
                    rules={[
                        {
                            required: true,
                            message: 'Please ensure the macro description has been entered.',
                        },
                    ]}
                >
                    <Input.TextArea rows={4} />
                </Form.Item>
                <Form.Item label='Content'>
                    <TextEditor onChange={setNote} content={note} />
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default AddMacroModal;
